import React from 'react';
import { motion } from 'framer-motion';
export function Input({
  label,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
}) {
  return <div className="flex flex-col gap-1.5 w-full" data-id="element-216">
      {label && <label className="text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-217">
          {label}
        </label>}
      <input className="glass-input rounded-lg px-4 py-2.5 w-full text-sm" {...props} data-id="element-218" />
    </div>;
}
export function Toggle({
  checked,
  onChange,
  label
}: {
  checked: boolean;
  onChange: (c: boolean) => void;
  label?: string;
}) {
  return <div className="flex items-center justify-between py-2" data-id="element-219">
      {label && <span className="text-sm font-medium text-slate-300" data-id="element-220">{label}</span>}
      <button type="button" onClick={() => onChange(!checked)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 focus:outline-none ${checked ? 'bg-emerald-500' : 'bg-slate-700'}`} data-id="element-221">
        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${checked ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-222" />
      </button>
    </div>;
}
export function SegmentedControl({
  options,
  value,
  onChange,
  id
}: {
  options: {
    label: string;
    value: string;
    colorClass?: string;
  }[];
  value: string;
  onChange: (v: string) => void;
  id?: string;
}) {
  const layoutKey = id || `segment-${Math.random().toString(36).slice(2, 8)}`;
  return <div className="flex p-1 space-x-1 bg-[#0B101E]/80 rounded-lg border border-white/5" data-id="element-223">
      {options.map(opt => {
      const isActive = value === opt.value;
      return <button key={opt.value} type="button" onClick={() => onChange(opt.value)} className={`relative flex-1 py-1.5 text-xs font-medium rounded-md transition-all duration-200 ${isActive ? 'text-white shadow-sm' : 'text-slate-400 hover:text-slate-200'}`} data-id="element-224">
            {isActive && <motion.div layoutId={layoutKey} className={`absolute inset-0 rounded-md ${opt.colorClass || 'bg-slate-700'}`} initial={false} transition={{
          type: 'spring',
          stiffness: 500,
          damping: 30
        }} data-id="element-225" />}
            <span className="relative z-10" data-id="element-226">{opt.label}</span>
          </button>;
    })}
    </div>;
}
export function FormPill({
  result,
  onClick
}: {
  result: 'G' | 'E' | 'P' | null;
  onClick: () => void;
}) {
  const colors = {
    G: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    E: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    P: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
    null: 'bg-slate-800/50 text-slate-500 border-slate-700/50 hover:bg-slate-800'
  };
  return <button type="button" onClick={onClick} className={`w-8 h-8 rounded-md flex items-center justify-center text-xs font-bold border transition-colors ${colors[result || 'null']}`} data-id="element-227">
      {result || '-'}
    </button>;
}